/**
 * Smooth open/close animation for the FAQ accordion rows on the
 * "Necesitas ayuda" page (collapsible-content section), matching the
 * animated feel of move.one's FAQ page. Scoped to
 * ".collapsible-content .accordion details" only, so every other
 * accordion in the theme (product description, size guide, etc.) keeps
 * its original instant native <details> behavior untouched.
 *
 * Pattern: https://web.dev/articles/building-a-dialog-component (animated
 * details recipe), adapted to plain <details>/<summary>.
 */
(function () {
  function AnimatedAccordion(details) {
    this.details = details;
    this.summary = details.querySelector('summary');
    this.content = details.querySelector('.accordion__content');
    this.animation = null;
    this.isClosing = false;
    this.isExpanding = false;
    this.onClick = this.onClick.bind(this);
    this.summary.addEventListener('click', this.onClick);
  }

  AnimatedAccordion.prototype.onClick = function (event) {
    event.preventDefault();
    this.details.style.overflow = 'hidden';
    if (this.isClosing || !this.details.open) {
      this.open();
    } else if (this.isExpanding || this.details.open) {
      this.shrink();
    }
  };

  AnimatedAccordion.prototype.shrink = function () {
    this.isClosing = true;
    var startHeight = this.details.offsetHeight + 'px';
    var endHeight = this.summary.offsetHeight + 'px';
    if (this.animation) this.animation.cancel();
    this.animation = this.details.animate(
      { height: [startHeight, endHeight] },
      { duration: 250, easing: 'ease-out' }
    );
    this.animation.onfinish = this.onAnimationFinish.bind(this, false);
    this.animation.oncancel = function () {
      this.isClosing = false;
    }.bind(this);
  };

  AnimatedAccordion.prototype.open = function () {
    this.details.style.height = this.details.offsetHeight + 'px';
    this.details.open = true;
    window.requestAnimationFrame(this.expand.bind(this));
  };

  AnimatedAccordion.prototype.expand = function () {
    this.isExpanding = true;
    var startHeight = this.details.offsetHeight + 'px';
    var endHeight = this.summary.offsetHeight + this.content.offsetHeight + 'px';
    if (this.animation) this.animation.cancel();
    this.animation = this.details.animate(
      { height: [startHeight, endHeight] },
      { duration: 250, easing: 'ease-out' }
    );
    this.animation.onfinish = this.onAnimationFinish.bind(this, true);
    this.animation.oncancel = function () {
      this.isExpanding = false;
    }.bind(this);
  };

  AnimatedAccordion.prototype.onAnimationFinish = function (open) {
    this.details.open = open;
    this.animation = null;
    this.isClosing = false;
    this.isExpanding = false;
    this.details.style.height = '';
    this.details.style.overflow = '';
  };

  function init() {
    document.querySelectorAll('.collapsible-content .accordion details').forEach(function (details) {
      if (details.dataset.faqAnimateInit) return;
      details.dataset.faqAnimateInit = 'true';
      new AnimatedAccordion(details);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
